import { adminTemplateState } from "../types/index"
import {adminTemplateMockData } from "../data"
export const initialState: adminTemplateState = {
    templates: adminTemplateMockData,
    isLoading: false,
    error: ""
};